import { LOCATION_CHANGE } from 'connected-react-router';
import { handleActions } from 'redux-actions';
import moment from 'moment';

import * as types from './types';

const initialState = {
  error: null,
  jobId: null,
  lastSync: null,
  loading: false,
  progress: null,
  saving: false,
  synced: false,
};

const locationChange = (state, payload) => {
  if (state.saving) {
    return { ...state };
  }
  return initialState;
};

const intacctLoginRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
    progress: null,
  };
};
const intacctLoginRequestFailure = (state, action) => {
  return {
    ...state,
    synced: false,
    lastSync: null,
    error: action.error,
    loading: false,
    progress: null,
  };
};
const intacctLoginRequestSuccess = (state) => {
  return {
    ...state,
    error: null,
    loading: false,
    progress: null,
  };
};

const intacctSyncRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const intacctSyncRequestFailure = (state, action) => {
  return {
    ...state,
    synced: false,
    lastSync: null,
    error: action.error,
    progress: null,
    saving: false,
  };
};
const intacctSyncRequestSuccess = (state, payload) => {
  return {
    ...state,
    error: null,
    jobId: payload.data.jobId,
    lastSync: null,
    saving: false,
    synced: false,
  };
};
const intacctSyncRequestProgress = (state, payload) => {
  return {
    ...state,
    progress: payload.data,
  };
};

const getSyncStatusRequest = (state) => {
  return {
    ...state,
    error: null,
    progress: '0',
    saving: true,
  };
};
const getSyncStatusRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    progress: null,
    saving: false,
  };
};
const getSyncStatusRequestSuccess = (state, payload) => {
  if (payload.data.progress === 100) {
    return {
      ...state,
      error: null,
      jobId: null,
      lastSync: moment().toISOString(),
      progress: '100',
      saving: false,
      synced: true,
    };
  }
  return {
    ...state,
    error: null,
    progress: payload.data.progress,
    saving: true,
  };
};

const getCompanySyncStatusRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const getCompanySyncStatusRequestFailure = (state, action) => {
  return {
    ...state,
    data: { syncError: action.error.message },
    error: null,
    saving: false,
  };
};
const getCompanySyncStatusRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: payload.data,
    error: null,
    saving: true,
  };
};
export default handleActions(
  {
    [LOCATION_CHANGE]: locationChange,
    [types.INTACCT_LOGIN_REQUEST]: intacctLoginRequest,
    [types.INTACCT_LOGIN_REQUEST_FAILURE]: intacctLoginRequestFailure,
    [types.INTACCT_LOGIN_REQUEST_SUCCESS]: intacctLoginRequestSuccess,
    [types.INTACCT_SYNC_REQUEST]: intacctSyncRequest,
    [types.INTACCT_SYNC_REQUEST_FAILURE]: intacctSyncRequestFailure,
    [types.INTACCT_SYNC_REQUEST_SUCCESS]: intacctSyncRequestSuccess,
    [types.INTACCT_SYNC_REQUEST_PROGRESS]: intacctSyncRequestProgress,
    [types.GET_SYNC_STATUS_REQUEST]: getSyncStatusRequest,
    [types.GET_SYNC_STATUS_REQUEST_FAILURE]: getSyncStatusRequestFailure,
    [types.GET_SYNC_STATUS_REQUEST_SUCCESS]: getSyncStatusRequestSuccess,
    [types.GET_COMPANY_SYNC_STATUS_REQUEST]: getCompanySyncStatusRequest,
    [types.GET_COMPANY_SYNC_STATUS_REQUEST_FAILURE]: getCompanySyncStatusRequestFailure,
    [types.GET_COMPANY_SYNC_STATUS_REQUEST_SUCCESS]: getCompanySyncStatusRequestSuccess,
  },
  initialState
);
